import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";

import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import {
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
} from "../../Expand";
import { filter, get, union, uniqBy, orderBy } from "lodash";

import { getTotalOrderPromo, getOldListPromo } from "../HeaderOrdersItem";

import { getNumber, defaultColumnDiscount } from "../utils";

class GridPromoDiscount extends Component {
  constructor(props) {
    super(props);

    const { item, formData, products } = props;

    // const { Criteria, Match } = item
    // let listProduct = filter(product, function (o) {
    //   return o[Criteria] === Match
    // })
    let listProduct = filter(products, function (o) {
      return o.subgroup_id === item.criteria.discount.buy.id;
    });
    if (get(item, "criteria.discount.buy.type", "") === "ProductCode") {
      listProduct = filter(products, function (o) {
        return o.code === item.criteria.discount.buy.id;
      });
    } else if (get(item, "criteria.discount.buy.type", "") === "ProductGroup") {
      listProduct = filter(products, function (o) {
        return o.group_id === item.criteria.discount.buy.id;
      });
    } else if (
      get(item, "criteria.discount.buy.type", "") === "ProductShortCode"
    ) {
      listProduct = filter(products, function (o) {
        return o.short_code === item.criteria.discount.buy.id;
      });
    }

    const listPromo = get(formData, "items", []);
    const allTotal = getTotalOrderPromo(listPromo, item);
    const latestListPromo = getOldListPromo(listPromo, item);

    if (latestListPromo) {
      const data = union(latestListPromo.listPromoDiscount, listProduct);
      listProduct = uniqBy(data, "code");
    } else {
      listProduct = filter(products, function (o) {
        if (o.subgroup_id === item.criteria.discount.buy.id) {
          o.discount = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.subgroup_id === item.criteria.discount.buy.id;
        } else if (o.code === item.criteria.discount.buy.id) {
          o.discount = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.code === item.criteria.discount.buy.id;
        } else if (o.group_id === item.criteria.discount.buy.id) {
          o.discount = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.group_id === item.criteria.discount.buy.id;
        } else if (o.short_code === item.criteria.discount.buy.id) {
          o.discount = 0;
          o.Order = 0;
          o.OrderAmt = 0;
          return o.short_code === item.criteria.discount.buy.id;
        }
        return false;
      });
    }
    this.state = {
      search: "",
      message: "",
      show: false,
      rowData: listProduct,
      columnDefs: defaultColumnDiscount,
      defaultColDef: {
        flex: 1,
        editable: true,
        sortable: true,
        filter: true,
        cellStyle: {
          "line-height": "40px",
        },
      },
      getRowNodeId: function (data) {
        return data.code;
      },
      listPromo: get(latestListPromo, "listPromoDiscount", []),
      item: props.item,
      tPromoOrderQty: allTotal.totalOrderQty,
      tPromoOrderAmt: allTotal.totalOrderAmt,
      expanded: "panelGridPromoDiscount",
      moqSelected: 0,
    };
  }

  onGridReady = (params) => {
    this.gridApiDiscount = params.api;
    this.gridColumnApiDiscount = params.columnApi;
  };

  onCellChanged(params, locale) {
    locale.onUpdateItem(params);
    // locale.props.onUpdatePromoProduct(params)
  }
  onGetMOQ = (qty) => {
    let discount = 0;
    const { item } = this.props;

    const moqs = orderBy(
      get(item, "criteria.discount.moqs", []),
      ["moq"],
      ["desc"]
    );

    if (moqs.length > 0) {
      if (qty >= moqs[0].moq) {
        return moqs[0].discount;
      } else if (qty >= moqs[1].moq) {
        return moqs[1].discount;
      } else if (qty >= moqs[2].moq) {
        return moqs[2].discount;
      }
    }

    return discount;
  };
  onGetDisc = (qty, price) => {
    let discount = 0;
    const { item } = this.props;
    const moqs = orderBy(
      get(item, "criteria.discount.moqs", []),
      ["moq"],
      ["desc"]
    );
    if (moqs.length > 0) {
      if (qty >= moqs[0].moq) {
        const myTotalResult =
          moqs[0].discount !== "" && moqs[0].discount > 0
            ? Number(price * moqs[0].discount).toFixed(2)
            : 0;
        return myTotalResult;
      } else if (qty >= moqs[1].moq) {
        const myTotalResult =
          moqs[1].discount !== "" && moqs[1].discount > 0
            ? Number(price * moqs[1].discount).toFixed(2)
            : 0;
        return myTotalResult;
      } else if (qty >= moqs[2].moq) {
        const myTotalResult =
          moqs[2].discount !== "" && moqs[2].discount > 0
            ? Number(price * moqs[2].discount).toFixed(2)
            : 0;
        return myTotalResult;
      }
    }

    return discount;
  };

  onUpdateItem = (params) => {
    if (params.data.Order && params.data.Order > 0) {
      const { listPromo } = this.state;
      let newListPromo = listPromo;
      // const DiscValue = ""

      const values = {
        ...params.data,
      };

      if (newListPromo.length === 0) {
        newListPromo.push(values);
      } else {
        let newList = filter(newListPromo, function (o) {
          return o.code !== params.data.code;
        });
        newListPromo = newList;
        newListPromo.push(values);
      }
      const tpoq = getNumber(newListPromo, "tPromoOrderQty");
      const tpoqa = getNumber(newListPromo, "tPromoOrderAmt");
      const valueDisc = this.onGetDisc(tpoq, params.data.price);
      if (this.state.moqSelected !== this.onGetMOQ(tpoq)) {
        this.setOrderDefaultList(parseFloat(valueDisc), this.onGetMOQ(tpoq));
      }
      this.setOrderAmtDefault(params.data.code, params.data);
      // this.setOrderDefault(params.data.ProductCode)

      this.setState({
        listPromo: newListPromo,
        tPromoOrderQty: tpoq,
        tPromoOrderAmt: tpoqa,
      });
      this.props.onUpdatePromoProduct(newListPromo, tpoq, tpoqa);
    }
  };

  handleChange = (panel) => (event, newExpanded) => {
    this.setState({
      expanded: newExpanded ? panel : false,
    });
  };

  setOrderDefault(ProductCode, value) {
    if (ProductCode) {
      var rowNode = this.gridApiDiscount.getRowNode(ProductCode);
      rowNode.setDataValue("discount", value);
    }
  }
  setOrderAmtDefault(ProductCode, item) {
    if (ProductCode) {
      var rowNode = this.gridApiDiscount.getRowNode(ProductCode);
      rowNode.setDataValue(
        "OrderAmt",
        Number(item.Order * item.price).toFixed(2)
      );
    }
  }
  setOrderDefaultList(value, moq) {
    const { rowData } = this.state;
    rowData.map((discount) => {
      if (discount.code) {
        var rowNode = this.gridApiDiscount.getRowNode(discount.code);
        rowNode.setDataValue("discount", value);
      }
      return "";
    });
    this.setState({ moqSelected: moq });
  }

  render() {
    const { translate } = this.props;

    return (
      <ExpansionPanel
        expanded={this.state.expanded === "panelGridPromoDiscount"}
        onChange={this.handleChange("panelGridPromoDiscount")}
      >
        <ExpansionPanelSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls='promotion_items-discount-content'
          id='promotion_items-discount-header'
        >
          <Typography>
            {translate("resources.po.listgrid.label.promo_items")} (
            {this.state.rowData.length}{" "}
            {this.state.rowData.length > 1
              ? translate("resources.po.listgrid.label.items")
              : translate("resources.po.listgrid.label.item")}
            )
          </Typography>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails
          style={{ width: "100%%", padding: 0, paddingTop: 4 }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            <div className='grid-wrapper'>
              <div
                id='myGrid'
                style={{
                  height: "55vh",
                  width: "100%",
                }}
                className='ag-theme-balham'
              >
                <AgGridReact
                  rowHeight={40}
                  headerHeight={40}
                  rowData={this.state.rowData}
                  columnDefs={this.state.columnDefs}
                  defaultColDef={this.state.defaultColDef}
                  animateRows={true}
                  getRowNodeId={this.state.getRowNodeId}
                  onGridReady={this.onGridReady}
                  onCellValueChanged={(params) =>
                    this.onCellChanged(params, this)
                  }
                />
              </div>
            </div>
          </div>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

export default GridPromoDiscount;
